module.exports = __webpack_public_path__ + "static/media/port.b7964bd5.png";